import { useState } from "react";
import AppShell from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { UtensilsCrossed, ListOrdered } from "lucide-react";
import ParentPreorder from "@/pages/ParentPreorder";
import ParentMyOrders from "@/pages/ParentMyOrders";

const TABS = [
  { key: "book",   label: "Book a meal", icon: UtensilsCrossed, desc: "Pre-order daily / special meals" },
  { key: "orders", label: "My orders",   icon: ListOrdered,    desc: "Placed orders & history" },
];

/**
 * Unified parent ordering page — combines daily pre-order booking
 * AND the parent's placed-order list under one route (/parent/my-orders).
 * Statement page removed; this is the single place for all order workflows.
 */
export default function ParentOrders() {
  const { user } = useAuth();
  const [tab, setTab] = useState("book");

  return (
    <AppShell variant={user?.role === "student" ? "student" : "parent"}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Orders</div>
            <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-ink mt-2">Pre-order &amp; order history</h1>
            <p className="text-sm text-ink-500 mt-1">{TABS.find(t => t.key === tab)?.desc}</p>
          </div>
        </div>

        <div className="inline-flex bg-cream-200 rounded-full p-1 mb-4">
          {TABS.map(t => {
            const Icon = t.icon;
            return (
              <button key={t.key} data-testid={`parent-orders-tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`px-5 py-2 rounded-full text-sm font-semibold flex items-center gap-2 transition-colors ${
                  tab === t.key ? "bg-brand text-white" : "text-ink-700 hover:bg-cream-300"
                }`}>
                <Icon size={14} /> {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {tab === "book"   && <ParentPreorder embedded />}
      {tab === "orders" && <ParentMyOrders embedded />}
    </AppShell>
  );
}
